export { default } from './FlashNotification';
